<template>
  <div class="container-fluid section">
    <div class="row heading">
      <div class="col">
        <h2>Pending Payments</h2>
      </div>
    </div>

    <div class="row table-head">
      <div class="col">Payer</div>
      <div class="col">Payee</div>
      <div class="col">Account</div>
      <div class="col">Date Posted</div>
      <div class="col">Account Status</div>
      <div class="col">Mrc</div>
      <div class="col">Amount</div>
      <div class="col text-right">Pay</div>
    </div>
    <div class="row table-subhead">
      <div class="col">
        <input type="text" class="form-control" v-model="search.payer_name" />
      </div>
     <div class="col">
        <input type="text" class="form-control" v-model="search.user_name" />
      </div>
      <div class="col">
        <input type="text" class="form-control" v-model="search.account_name" />
      </div>


      <div class="col">&nbsp;</div>
      <div class="col">
        <multi-select
        :list="getStatusList"
        placeholder="Filter By Account Status"
        @input="setAccountStatus"
        :value="getSelectedStatuses"

      ></multi-select>
      </div>
      <div class="col">&nbsp;</div>
      <div class="col">&nbsp;</div>
      <div class="col">&nbsp;</div>

    </div>
    <div class="row lined" v-for="p in pendingPayments">
        <div class="col" @click="search.payer_name = p.payer_name">{{p.payer_name}}</div>
        <div class="col" @click="search.user_name = p.user_name">{{p.user_name}}</div>
        <div class="col" @click="search.account_name = p.account_name">{{p.account_name}}</div>
        <div class="col">{{p.date_posted | formatDate}}</div>
        <div class="col">{{p.account_status}}</div>
        <div class="col">${{p.account_mrc}}</div>
        <div class="col">${{p.amount}}</div>
        <div class="col text-right">

          <dropdown-confirmation
            title="Are you sure you want to process this payment now?"
            triggerBtnClass="btn btn-light btn-sm"
            triggerBtnHtml="Pay"
            confirmBtnHtml="Pay this account"
            confirmBtnClass="btn-success"
            @confirm="pay(p)"
          ></dropdown-confirmation>


          <dropdown-confirmation
            title="Are you sure you wnat to process this payment reversal?"
            triggerBtnClass="btn btn-light btn-sm"
            triggerBtnHtml="Reverse"
            confirmBtnHtml="Reverse this payment"
            confirmBtnClass="btn-danger"
            @confirm="reverse(p)"
          ></dropdown-confirmation>
        </div>
    </div>


  </div>
</template>
<script type="text/babel">
  import Dropdown from '../assets/Dropdown.vue';
  import MultiSelect from '../assets/MultiSelect.vue';
  import vueSlider from 'vue-slider-component';
  import DropdownConfirmation from '../assets/DropdownConfirmation.vue';

  export default {
    name: "PendingPayments",
    data: function(){
      return {
        search:{
          payer_name: '',
          account_name: '',
          user_name: '',
       //   date_posted: '',
          account_status: [],
       //   account_mrc: [0,1000],
       //   amount: [0,1000]
        },
        pendingPayments:[],
        accountStatuses: []
      }
    },
    components:{
      MultiSelect,
      DropdownConfirmation
    },
    created(){
      this.fetchData();
      this.fetchStatuses();
    },
    computed:{
      /*
      getPayerNames(){
        var names = [];
        if(!this.pendingPayments) return [];fetchData
        this.pendingPayments.forEach(function(p){
            if(names.indexOf(p.payer_name) < 0) names.push(p.payer_name);
        })
        return names;
      },
      getAccountNames(){
        var names = [];
        if(!this.pendingPayments) return [];
        this.pendingPayments.forEach(function(p){
          if(names.indexOf(p.account_name) < 0) names.push(p.account_name);
        })
        return names;
      },
      */
      getStatusList(){
        return this.accountStatuses.map(function(status){

          return status.name;
        });
      },
      getSelectedStatuses(){
        var _this = this;
        if(!this.accountStatuses) return false;
        return this.accountStatuses.filter(function(s){
          return _this.search.account_status.indexOf(s.id) >=0;
        }).map(function(s){
          return s.name;
        });
      },
    },

    filters:{
      formatDate(date){
        return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY')
      }
    },
    methods:{

      pay(p){

        this.$send(this, 'pay',{
          accountCashflow_id: p.accountCashflow_id
        }).then(r => {
          this.fetchData()
        });

      },
      reverse(p){

        this.$send(this, 'reverse',{
          accountCashflow_id: p.accountCashflow_id
        }).then(r => {
          this.fetchData()
        });

      },
      fetchData(){

        this.$send(this, 'pendingPayments',{
          search: this.search
        }).then(r => {
          this.pendingPayments = r.pendingPayments;
        });

      },
      setAccountStatus(value){

        var status_id = this.accountStatuses.filter(function(s){
          return s.name == value;
        }).map(function(s){
          return s.id;
        })[0];

        if(this.search.account_status.indexOf(status_id) >=0){
          this.search.account_status.splice(this.search.account_status.indexOf(status_id), 1)
        } else {
          this.search.account_status.push(status_id);
        }
      },
      fetchStatuses(){

        this.$send(this, 'accountStatuses').then(r => {
          this.accountStatuses = r.accountStatuses;
        });
      }
    },
    watch:{
      search: {
        handler: function () {
          this.fetchData();
        },
        deep: true
      }
    },
  }

</script>



// WEBPACK FOOTER //
// PendingPayments.vue?f4454abe